import { Locale } from '@js-joda/locale_en-us'

export const ENGLISH_LOCALE = Locale.ENGLISH
